import { c as _c } from "react/compiler-runtime";
import { useTheme } from "next-themes";
import { Toaster as Sonner } from "sonner";
import { jsx as _jsx } from "react/jsx-runtime";
const Toaster = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "light" : t1;
  const t2 = theme;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      classNames: {
        error: "!border-none !bg-toast-error !text-foreground",
        info: "!border-none !bg-toast-info !text-foreground",
        loading: "!border-none !bg-toast-loading !text-foreground",
        success: "!border-none !bg-toast-success !text-foreground",
        warning: "!border-none !bg-toast-warning !text-foreground"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props || $[4] !== t2) {
    t4 = /*#__PURE__*/_jsx(Sonner, {
      theme: t2,
      toastOptions: t3,
      ...props
    });
    $[3] = props;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export { Toaster };